<script type="text/jsx">
import vuescroll from 'vuescroll'

import Nav from '@/components/Nav/Nav'
import {
  StyledMenu,
  StyledButton,
  StyledSocialList,
  StyledSocialItem,
  StyledLink,
  StyledLinkEmail,
  StyledOverflow
} from './StyledMenu'

export default {
  name: 'Menu',
  data: () => ({
    scrollOptions: {
      bar: {
        background: '#808080',
        keepShow: false,
        size: '4px',
        minSize: 0.8
      }
    }
  }),
  methods: {
    handleClick () {
      this.$router.push({ path: '/' })
      this.$emit('close')
    }
  },
  props: ['active'],
  components: {
    vuescroll
  },
  render () {
    return (
      <StyledMenu>
        <vuescroll ops={this.scrollOptions}>
          <Nav
            class={'nav_main ' + (this.active && 'nav_active')} menu={this.active}
            transitionName="transition"
            onClose={() => { this.$emit('close') }}
          />
          <StyledOverflow>
            <StyledButton onClick={() => { this.handleClick() }} transition={this.active}>Заявка на сервис</StyledButton>
          </StyledOverflow>
          <StyledOverflow>
            <StyledButton onClick={() => { this.handleClick() }} margin transition={this.active}>Проверка статуса</StyledButton>
          </StyledOverflow>
          <StyledSocialList>
            <StyledSocialItem>
              <transition name="transition">
                {this.active
                  ? <StyledLink href={this.$t('base.viber.link')}>{this.$t('base.viber.text')}</StyledLink>
                  : null}
              </transition>
            </StyledSocialItem>
            <StyledSocialItem>
              <transition name="transition">
                {this.active
                  ? <StyledLink href={this.$t('base.telegram.link')}>{this.$t('base.telegram.text')}</StyledLink>
                  : null}
              </transition>
            </StyledSocialItem>
          </StyledSocialList>
          <StyledOverflow>
            <StyledLinkEmail transition={this.active} href={`mailto:${this.$t('base.email')}`}>{this.$t('base.email')}</StyledLinkEmail>
          </StyledOverflow>
        </vuescroll>
      </StyledMenu>
    )
  }
}
</script>
<style scoped>
  .transition-enter-active {
    transition: all .5s ease-out;
  }
  .transition-leave-active {
    transition: all .3s ease-out;
  }
  .transition-enter {
    opacity: 0;
    transform: translateY(-100px);
  }
  .transition-leave-to {
    opacity: 0;
    transform: translateY(-100px);
  }
</style>



// WEBPACK FOOTER //
// src/components/Menu/Menu.vue